export default {
  install: (app) => {
    app.config.globalProperties.I18n = window.I18n
  },
}
